module.exports = __webpack_public_path__ + "img/course-default.bf4850b4.png";